export default __webpack_public_path__ + "static/media/desk6.d420d687.png";